import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { UserAuthenticationService } from '../../../modules/authentication/services/user-authentication.service';
import { Icon } from '../../models/icon';
@Component({
  selector: 'app-logout-confirmation',
  templateUrl: './logout-confirmation.component.html',
  styleUrls: ['./logout-confirmation.component.scss']
})
export class LogoutConfirmationComponent{
  @ViewChild('logoutConfirmModal') logoutConfirmModal: ModalComponent;
  Icon = Icon;

  constructor(
    private readonly userAuthentication: UserAuthenticationService
  ) { }

  public logoutConfirmOpen(): void {
    this.logoutConfirmModal.openModal();
  }

  protected logoutConfirm(flag: boolean): boolean | void {
    this.logoutConfirmModal.closeModal();
    if (!flag){
      return false;
    }else
    {
      this.userAuthentication.logout();
    }
  }
}
